import React from 'react';
import { Link } from 'react-router-dom';

const LoginLayoutA = ({
  email, setEmail,
  password, setPassword,
  error, loading,
  onSubmit
}) => {
  return (
    <div className="aut-auth-container">
      <div className="aut-auth-card">
        <div className="aut-auth-header">
          <h1 className="aut-auth-title">Welcome back</h1>
          <p className="aut-auth-subtitle">Sign in to your account to continue</p>
        </div>

        {error && (
          <div className="aut-alert aut-alert-error">
            {error}
          </div>
        )}

        <form className="aut-form" onSubmit={onSubmit}>
          <div className="aut-form-group">
            <label className="aut-label" htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              className="aut-input"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
            />
          </div>

          <div className="aut-form-group">
            <label className="aut-label" htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              className="aut-input"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            className="aut-btn aut-btn-primary aut-btn-full"
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>

        <div className="aut-auth-footer">
          Don't have an account?{' '}
          <Link to="/register" className="aut-auth-link">
            Create one
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LoginLayoutA;
